/*
 * -----------------------------------------------------------------------
 *  <copyright file="reports.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import {
    CustomReportResultFragment,
    ReportFragment,
    ReportSignatoryFragment
} from './fragments';

export const GET_REPORT_SIGNATORIES = gql`
    query getReportSignatories($studyId: ObjectId!, $template: String!) {
        reportSignatories(studyId: $studyId, template: $template) {
            ...ReportSignatoryFields
        }
    }    
    ${ReportSignatoryFragment}
`;

export const SAVE_REPORT_SIGNATORY = gql`
    mutation saveSignatory($studyId: ObjectId!, $template: String!, $signatory: ReportSignatoryInput!) {
        saveSignatory(studyId: $studyId, template: $template, signatory: $signatory) {
            ...ReportSignatoryFields
        }
    }
    ${ReportSignatoryFragment}
`;

export const DELETE_REPORT_SIGNATORY = gql`
    mutation deleteSignatory($studyId: ObjectId!, $template: String!, $id: ObjectId!) {
        deleteSignatory(studyId: $studyId, template: $template, id: $id)
    }
`;

export const GET_REPORTS = gql`
    query reports($studyId: ObjectId!, $template: String!) {
        reports(studyId: $studyId, template: $template) {
            ...ReportFields
        }
    }
    ${ReportFragment}
`;

export const EDIT_REPORT = gql`
    mutation editReport($id: ObjectId!, $status: ReportStatus!, $comment: String!) {
        editReport(id: $id, status: $status, comment: $comment)
    }
`;

export const GET_PDF_REPORT = gql`
    query pdfReport($id: ObjectId!) {
        pdfReport(id: $id)  
    }
`;

export const GENERATE_CSV_REPORT = gql`
    query generateCsvReport($studyId: ObjectId!, $template: String!) {
        generateCsvReport(studyId: $studyId, template: $template)
    }
`;

export const GENERATE_PDF_REPORT = gql`
    mutation generatePdfReport($studyId: ObjectId!, $template: String!, $dataSetId: ObjectId, $onlyReviewed: Boolean) {
        generatePdfReport(studyId: $studyId, template: $template, dataSetId: $dataSetId, onlyReviewed: $onlyReviewed) {
            ...ReportFields
        }
    }
    ${ReportFragment}
`;

export const GENERATE_CUSTOM_REPORT = gql`
    query generateCustomReport($id: ObjectId!, $studyId: ObjectId!) {
        generateCustomReport(id: $id, studyId: $studyId) {
            ...CustomReportResultFields
        }
    }
    ${CustomReportResultFragment}
`;

